import {
  AdPreviewGridLayout as GridLayoutCore,
  AdPreviewWaterfallGridLayout as WaterfallGridLayoutCore,
  AdPreviewSinglePlacementLayout as SinglePlacementLayoutCore,
  UnstyledAdPreviewCarouselLayout as UnstyledCarouselLayoutCore,
  //
  AdPlacementMmaWideImage4x1 as MmaWideImage4x1,
  AdPlacementMmaLandscapeImage191x100 as MmaLandscapeImage191x100,
  AdPlacementMmaSquareImage1x1 as MmaSquareImage1x1,
  AdPlacementMmaVerticalImage1x2 as MmaVerticalImage1x2,
  AdPreviewPlacementContainerBase as AdPreviewPlacementContainerBaseCore,
  //
  AdPlacementMmaInMsanWideImage191x100 as MmaInMsanWideImage191x100,
  AdPlacementMmaInMsanSquareImage1x1 as MmaInMsanSquareImage1x1,
  AdPlacementMmaInMsanMSEdgeSingleCarousel178x100 as MmaInMsanMSEdgeSingleCarousel178x100,
  AdPlacementMmaInMsanMSNInArticle150x100 as MmaInMsanMSNInArticle150x100,
  AdPlacementMmaInMsanMSNSmallHeadline133x100 as MmaInMsanMSNSmallHeadline133x100,
  //
  AdPlacementMmaInMsanV2MicrosoftEdgeCarousel201x100 as MmaInMsanV2MicrosoftEdgeCarousel201x100,
  AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1 as MmaInMsanV2MicrosoftEdgeMobile1x1,
  AdPlacementMmaInMsanV2MSANBanner2x1 as MmaInMsanV2MSANBanner2x1,
  AdPlacementMmaInMsanV2MSANRiver191x100 as MmaInMsanV2MSANRiver191x100,
  AdPlacementMmaInMsanV2MSANRectangle191x100 as MmaInMsanV2MSANRectangle191x100,
  AdPlacementMmaInMsanV2MSANRectangle120x100 as MmaInMsanV2MSANRectangle120x100,
  AdPlacementMmaInMsanV2MSNCarousel169x100 as MmaInMsanV2MSNCarousel169x100,
  AdPlacementMmaInMsanV2MSNPartnerStripe153x100 as MmaInMsanV2MSNPartnerStripe153x100,
  AdPlacementMmaInMsanV2MSNRestoday124x100 as MmaInMsanV2MSNRestoday124x100,
  // Boost
  AdPlacementBoostHeroImageCarousel as BoostHeroImageCarousel,
  AdPlacementBoostWindowsSpotlight191x100 as BoostWindowsSpotlight191x100,
  AdPlacementBoostDiscoverCard1x1 as BoostDiscoverCard1x1,
  AdPlacementBoostStartMenu as BoostStartMenu,
  AdPlacementBoostActionCenter as BoostActionCenter,
  AdPlacementBoostBanner as BoostBanner,
  AdPlacementBoostProngFeed191x100 as BoostProngFeed191x100,
  AdPlacementBoostCoachmark175x100 as BoostCoachmark175x100,
  //
  AdPlacementImgExtWideImage191x100 as ImgExtWideImage191x100,
  AdPlacementImgExtMSEdgeSingleCarousel178x100 as MSEdgeSingleCarousel178x100,
  AdPlacementImgExtBingDesktopSingleImage178x100 as BingDesktopSingleImage178x100,
  AdPlacementImgExtMSEdgeMediumHeadline172x100 as MSEdgeMediumHeadline172x100,
  AdPlacementImgExtMSNSingleCarousel169x100 as MSNSingleCarousel169x100,
  AdPlacementImgExtMSNMediumHeadline155x100 as MSNMediumHeadline155x100,
  AdPlacementImgExtMSNInArticle150x100 as MSNInArticle150x100,
  AdPlacementImgExtMSNSmallHeadline133x100 as MSNSmallHeadline133x100,
  AdPlacementImgExtBingDesktopMultiImage133x100 as BingDesktopMultiImage133x100,
  AdPlacementImgExtBingMobileMultiImage133x100 as BingMobileMultiImage133x100,
  AdPlacementImgExtSquareImage1x1 as SquareImage1x1,
  AdPlacementImgExtMSNDoubleCarousel93x100 as MSNDoubleCarousel93x100,
  //
  ResponsiveAdPlacementMmaLandscapeImage191x100 as ResponsiveMmaLandscapeImage191x100,
  ResponsiveAdPlacementMmaSquareImage1x1 as ResponsiveMmaSquareImage1x1,
  ResponsiveAdPlacementMmaVerticalImage1x2 as ResponsiveMmaVerticalImage1x2,
  ResponsiveAdPlacementMmaWideImage4x1 as ResponsiveMmaWideImage4x1,
  //
  ResponsiveAdPlacementMmaInMsanMSEdgeSingleCarousel178x100 as ResponsiveMmaInMsanMSEdgeSingleCarousel178x100,
  ResponsiveAdPlacementMmaInMsanMSNInArticle150x100 as ResponsiveMmaInMsanMSNInArticle150x100,
  ResponsiveAdPlacementMmaInMsanMSNSmallHeadline133x100 as ResponsiveMmaInMsanMSNSmallHeadline133x100,
  ResponsiveAdPlacementMmaInMsanSquareImage1x1 as ResponsiveMmaInMsanSquareImage1x1,
  ResponsiveAdPlacementMmaInMsanWideImage191x100 as ResponsiveMmaInMsanWideImage191x100,
  //
  ResponsiveAdPlacementBingSearchText as ResponsiveBingSearchText,
  ResponsiveAdPlacementOutlookMobile as ResponsiveOutlookMobile,
  ResponsiveAdPlacementOutlookWeb as ResponsiveOutlookWeb,
  //
  UAPPlacementType,
  UAPPlacementTypeAlias,
  //
  getAdPlacementComponent,
  //
  getPlacementListMetaDataByImageType,
  //
  UAPAdExtensionType,
  AdPreviewStructuredSnippetExtension as StructuredSnippetExtension,
  AdPreviewCalloutExtension as CalloutExtension,
  AdPreviewPriceExtension as PriceExtension,
  AdPreviewPromotionExtension as PromotionExtension,
  AdPreviewSitelinkExtension as SitelinkExtension,
  //
  AdPlacementDynamicSearch as DynamicSearch,
  //
  AdPlacementResponsiveSearch as ResponsiveSearch,
  AdPlacementResponsiveSearchDesktop as ResponsiveSearchDesktop,
  AdPlacementResponsiveSearchMobile as ResponsiveSearchMobile,
  //
  AdPlacementLinkedInSingleImageDesktop as LinkedInSingleImageDesktop,
  AdPlacementLinkedInSingleImageMobile as LinkedInSingleImageMobile,
  AdPlacementLinkedInSingleImageMediumRectangle as LinkedInSingleImageMediumRectangle,
  AdPlacementLinkedInSingleImageMobileInterstitial as LinkedInSingleImageMobileInterstitial,
  AdPlacementLinkedInSingleImageNative as LinkedInSingleImageNative,

  // app ads
  AppAdsVideoHorizontalPlacement as UnifiedAppAdsVideoHorizontalPlacement,
  AppAdsM365OutlookPlacement as UnifiedAppAdsM365OutlookPlacement,
  AppAdsCasualGamesDimensionsPlacement as UnifiedAppAdsCasualGamesDimensionsPlacement,
  AppAdsMSNDisplayPlacement as UnifiedAppAdsMSNDisplayPlacement,
  AppAdsBingSearchPlacement as UnifiedAppAdsBingSearchPlacement,

  getCropSettingsFromRoi,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import {
  AdPreviewCarouselLayoutWrapper,
  AdPreviewCarouselLayoutWrapperEx,
} from './src/carousel-layout-wrapper';
import { withCMUITheme } from './with-cmui-theme';

//
import { useAdPreviewModel } from './src/use-ad-preview-model-wrapper';

export const AdPreviewGridLayout = withCMUITheme(GridLayoutCore);
export const AdPreviewWaterfallGridLayout = withCMUITheme(WaterfallGridLayoutCore);
export const AdPreviewSinglePlacementLayout = withCMUITheme(SinglePlacementLayoutCore);
export const AdPreviewCarouselLayout = withCMUITheme(AdPreviewCarouselLayoutWrapper);
export const AdPreviewCarouselLayoutEx = withCMUITheme(AdPreviewCarouselLayoutWrapperEx);
export const UnstyledAdPreviewCarouselLayout = withCMUITheme(UnstyledCarouselLayoutCore);

export const AdPlacementMmaWideImage4x1 = withCMUITheme(MmaWideImage4x1);
export const AdPlacementMmaLandscapeImage191x100 = withCMUITheme(MmaLandscapeImage191x100);
export const AdPlacementMmaSquareImage1x1 = withCMUITheme(MmaSquareImage1x1);
export const AdPlacementMmaVerticalImage1x2 = withCMUITheme(MmaVerticalImage1x2);
export const AdPreviewPlacementContainerBase = withCMUITheme(AdPreviewPlacementContainerBaseCore);

export const AdPlacementMmaInMsanWideImage191x100 = withCMUITheme(MmaInMsanWideImage191x100);
export const AdPlacementMmaInMsanSquareImage1x1 = withCMUITheme(MmaInMsanSquareImage1x1);
export const AdPlacementMmaInMsanMSEdgeSingleCarousel178x100 = withCMUITheme(MmaInMsanMSEdgeSingleCarousel178x100);
export const AdPlacementMmaInMsanMSNInArticle150x100 = withCMUITheme(MmaInMsanMSNInArticle150x100);
export const AdPlacementMmaInMsanMSNSmallHeadline133x100 = withCMUITheme(MmaInMsanMSNSmallHeadline133x100);

export const AdPlacementMmaInMsanV2MicrosoftEdgeCarousel201x100 = withCMUITheme(MmaInMsanV2MicrosoftEdgeCarousel201x100);
export const AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1 = withCMUITheme(MmaInMsanV2MicrosoftEdgeMobile1x1);
export const AdPlacementMmaInMsanV2MSANBanner2x1 = withCMUITheme(MmaInMsanV2MSANBanner2x1);
export const AdPlacementMmaInMsanV2MSANRiver191x100 = withCMUITheme(MmaInMsanV2MSANRiver191x100);
export const AdPlacementMmaInMsanV2MSANRectangle191x100 = withCMUITheme(MmaInMsanV2MSANRectangle191x100);
export const AdPlacementMmaInMsanV2MSANRectangle120x100 = withCMUITheme(MmaInMsanV2MSANRectangle120x100);
export const AdPlacementMmaInMsanV2MSNCarousel169x100 = withCMUITheme(MmaInMsanV2MSNCarousel169x100);
export const AdPlacementMmaInMsanV2MSNPartnerStripe153x100 = withCMUITheme(MmaInMsanV2MSNPartnerStripe153x100);
export const AdPlacementMmaInMsanV2MSNRestoday124x100 = withCMUITheme(MmaInMsanV2MSNRestoday124x100);

export const AdPlacementBoostHeroImageCarousel = withCMUITheme(BoostHeroImageCarousel);
export const AdPlacementBoostWindowsSpotlight191x100 = withCMUITheme(BoostWindowsSpotlight191x100);
export const AdPlacementBoostDiscoverCard1x1 = withCMUITheme(BoostDiscoverCard1x1);
export const AdPlacementBoostStartMenu = withCMUITheme(BoostStartMenu);
export const AdPlacementBoostActionCenter = withCMUITheme(BoostActionCenter);
export const AdPlacementBoostBanner = withCMUITheme(BoostBanner);
export const AdPlacementBoostProngFeed191x100 = withCMUITheme(BoostProngFeed191x100);
export const AdPlacementBoostCoachmark175x100 = withCMUITheme(BoostCoachmark175x100);

export const AdPlacementImgExtWideImage191x100 = withCMUITheme(ImgExtWideImage191x100);
export const AdPlacementImgExtMSEdgeSingleCarousel178x100 = withCMUITheme(MSEdgeSingleCarousel178x100);
export const AdPlacementImgExtBingDesktopSingleImage178x100 = withCMUITheme(BingDesktopSingleImage178x100);
export const AdPlacementImgExtMSEdgeMediumHeadline172x100 = withCMUITheme(MSEdgeMediumHeadline172x100);
export const AdPlacementImgExtMSNSingleCarousel169x100 = withCMUITheme(MSNSingleCarousel169x100);
export const AdPlacementImgExtMSNMediumHeadline155x100 = withCMUITheme(MSNMediumHeadline155x100);
export const AdPlacementImgExtMSNInArticle150x100 = withCMUITheme(MSNInArticle150x100);
export const AdPlacementImgExtMSNSmallHeadline133x100 = withCMUITheme(MSNSmallHeadline133x100);
export const AdPlacementImgExtBingDesktopMultiImage133x100 = withCMUITheme(BingDesktopMultiImage133x100);
export const AdPlacementImgExtBingMobileMultiImage133x100 = withCMUITheme(BingMobileMultiImage133x100);
export const AdPlacementImgExtSquareImage1x1 = withCMUITheme(SquareImage1x1);
export const AdPlacementImgExtMSNDoubleCarousel93x100 = withCMUITheme(MSNDoubleCarousel93x100);

export const AdPlacementDynamicSearch = withCMUITheme(DynamicSearch);

export const AdPlacementResponsiveSearch = withCMUITheme(ResponsiveSearch);
export const AdPlacementResponsiveSearchDesktop = withCMUITheme(ResponsiveSearchDesktop);
export const AdPlacementResponsiveSearchMobile = withCMUITheme(ResponsiveSearchMobile);

export const ResponsiveAdPlacementMmaLandscapeImage191x100 = withCMUITheme(ResponsiveMmaLandscapeImage191x100);
export const ResponsiveAdPlacementMmaSquareImage1x1 = withCMUITheme(ResponsiveMmaSquareImage1x1);
export const ResponsiveAdPlacementMmaVerticalImage1x2 = withCMUITheme(ResponsiveMmaVerticalImage1x2);
export const ResponsiveAdPlacementMmaWideImage4x1 = withCMUITheme(ResponsiveMmaWideImage4x1);
export const ResponsiveAdPlacementMmaInMsanMSEdgeSingleCarousel178x100 = withCMUITheme(ResponsiveMmaInMsanMSEdgeSingleCarousel178x100);
export const ResponsiveAdPlacementMmaInMsanMSNInArticle150x100 = withCMUITheme(ResponsiveMmaInMsanMSNInArticle150x100);
export const ResponsiveAdPlacementMmaInMsanMSNSmallHeadline133x100 = withCMUITheme(ResponsiveMmaInMsanMSNSmallHeadline133x100);
export const ResponsiveAdPlacementMmaInMsanSquareImage1x1 = withCMUITheme(ResponsiveMmaInMsanSquareImage1x1);
export const ResponsiveAdPlacementMmaInMsanWideImage191x100 = withCMUITheme(ResponsiveMmaInMsanWideImage191x100);
export const ResponsiveAdPlacementBingSearchText = withCMUITheme(ResponsiveBingSearchText);
export const ResponsiveAdPlacementOutlookMobile = withCMUITheme(ResponsiveOutlookMobile);
export const ResponsiveAdPlacementOutlookWeb = withCMUITheme(ResponsiveOutlookWeb);

export const AdPlacementLinkedInSingleImageDesktop = withCMUITheme(LinkedInSingleImageDesktop);
export const AdPlacementLinkedInSingleImageMobile = withCMUITheme(LinkedInSingleImageMobile);
export const AdPlacementLinkedInSingleImageMediumRectangle = withCMUITheme(LinkedInSingleImageMediumRectangle);
export const AdPlacementLinkedInSingleImageMobileInterstitial = withCMUITheme(LinkedInSingleImageMobileInterstitial);
export const AdPlacementLinkedInSingleImageNative = withCMUITheme(LinkedInSingleImageNative);

export const AppAdsVideoHorizontalPlacement = withCMUITheme(UnifiedAppAdsVideoHorizontalPlacement);
export const AppAdsM365OutlookPlacement = withCMUITheme(UnifiedAppAdsM365OutlookPlacement);
export const AppAdsCasualGamesDimensionsPlacement = withCMUITheme(UnifiedAppAdsCasualGamesDimensionsPlacement);
export const AppAdsMSNDisplayPlacement = withCMUITheme(UnifiedAppAdsMSNDisplayPlacement);
export const AppAdsBingSearchPlacement = withCMUITheme(UnifiedAppAdsBingSearchPlacement);

export {
  UAPPlacementType,
  UAPPlacementTypeAlias,
  UAPAdExtensionType,
  useAdPreviewModel,
  getAdPlacementComponent,
  getPlacementListMetaDataByImageType,
  getCropSettingsFromRoi,
};

export { getSmartCropSettingsFactory } from './src/get-smart-cropped-image';

export { useImageExperienceAdPreviewModel, PlacementType2AssociationTypeMap } from './src/use-image-experience-ad-preview-model';

export const AdPreviewStructuredSnippetExtension = withCMUITheme(StructuredSnippetExtension);
export const AdPreviewCalloutExtension = withCMUITheme(CalloutExtension);
export const AdPreviewPriceExtension = withCMUITheme(PriceExtension);
export const AdPreviewPromotionExtension = withCMUITheme(PromotionExtension);
export const AdPreviewSitelinkExtension = withCMUITheme(SitelinkExtension);
export const AdPreviewAdExtensionComponents = {
  [UAPAdExtensionType.SiteLink]: AdPreviewSitelinkExtension,
  [UAPAdExtensionType.Callout]: AdPreviewCalloutExtension,
  [UAPAdExtensionType.Promotion]: AdPreviewPromotionExtension,
  [UAPAdExtensionType.StructuredSnippet]: AdPreviewStructuredSnippetExtension,
  [UAPAdExtensionType.Price]: AdPreviewPriceExtension,
};
